import { loanService } from "@/modules/loan/store/services/loan-service";

const getLoan = loanService.injectEndpoints({
  endpoints: builder => ({
    getLoan: builder.query({
      query: id => `loans/${id}`,
      providesTags: (result, error, id) => [{ type: "Loan", id }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetLoanQuery } = getLoan;

